module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aks"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "aks-loading"
  }, [_c('div', {
    staticClass: "aks-spinner"
  })]) : _vm._e(), _vm._v(" "), (_vm.loadError && !_vm.loading) ? _c('div', {
    staticClass: "aks-error"
  }, [_c('p', {
    staticClass: "aks-error-title"
  }, [_vm._v("Could not load API keys")]), _vm._v(" "), _c('p', {
    staticClass: "aks-error-msg"
  }, [_vm._v(_vm._s(_vm.loadError))]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchAll
    }
  }, [_vm._v("Retry")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.loadError) ? [_c('div', {
    staticClass: "aks-page-head"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showForm) ? _c('button', {
    staticClass: "aks-btn aks-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "6px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Create API key\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aks-hint-banner",
    attrs: {
      "role": "note"
    }
  }, [_c('svg', {
    staticStyle: {
      "flex-shrink": "0"
    },
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16v-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8h.01"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.showForm) ? _c('div', {
    staticClass: "aks-card aks-form-card"
  }, [_c('h3', {
    staticClass: "aks-form-title"
  }, [_vm._v("Create API key")]), _vm._v(" "), (_vm.formError) ? _c('div', {
    staticClass: "aks-alert-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.formError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aks-field"
  }, [_c('label', {
    staticClass: "aks-field-label"
  }, [_vm._v("KEY NAME")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formName),
      expression: "formName"
    }],
    staticClass: "aks-input",
    attrs: {
      "type": "text",
      "placeholder": "e.g. Production script, Zapier integration",
      "maxlength": "100",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.formName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "aks-field-hint"
  }, [_vm._v("Optional — helps you identify this key later.")])]), _vm._v(" "), _c('div', {
    staticClass: "aks-form-actions"
  }, [_c('button', {
    staticClass: "aks-btn aks-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-primary",
    class: {
      'aks-btn-loading': _vm.submitting
    },
    attrs: {
      "type": "button",
      "disabled": _vm.submitting
    },
    on: {
      "click": _vm.createKey
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitting ? 'Creating…' : 'Create key') + "\n        ")])])]) : _vm._e(), _vm._v(" "), (!_vm.apiKeys.length && !_vm.showForm) ? _c('div', {
    staticClass: "aks-empty"
  }, [_c('svg', {
    staticClass: "aks-empty-icon",
    attrs: {
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4",
      "y": "14",
      "width": "40",
      "height": "24",
      "rx": "3",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "17",
      "cy": "26",
      "r": "5",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 26h10M32 26l4 4M32 26l4-4",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "17",
      "cy": "26",
      "r": "2",
      "fill": "currentColor",
      "opacity": "0.35"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "aks-empty-title"
  }, [_vm._v("No API keys yet")]), _vm._v(" "), _c('p', {
    staticClass: "aks-empty-sub"
  }, [_vm._v("Create a key to authenticate your scripts and integrations with the SentryKit REST API.")]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-right": "5px",
      "vertical-align": "-1px"
    },
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v("\n        Create API key\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.apiKeys.length) ? _c('div', {
    staticClass: "aks-card"
  }, [_c('table', {
    staticClass: "aks-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.apiKeys), function(key) {
    return _c('tr', {
      key: key.id,
      class: {
        'aks-row-revoked': key.revoked_at
      }
    }, [_c('td', {
      staticClass: "aks-cell-name"
    }, [_c('span', {
      staticClass: "aks-key-name"
    }, [_vm._v(_vm._s(key.name || 'Unnamed key'))]), _vm._v(" "), (key.revoked_at) ? _c('span', {
      staticClass: "aks-badge-revoked"
    }, [_vm._v("Revoked")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-key"
    }, [_c('code', {
      staticClass: "aks-prefix"
    }, [_vm._v(_vm._s(key.token_prefix)), _c('span', {
      staticClass: "aks-prefix-dots"
    }, [_vm._v("••••")])])]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-scopes"
    }, _vm._l((key.scopes), function(s) {
      return _c('span', {
        key: s,
        staticClass: "aks-scope-chip"
      }, [_vm._v(_vm._s(s))])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-meta"
    }, [_vm._v(_vm._s(key.last_used_at ? _vm.formatDate(key.last_used_at) : 'Never'))]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-meta"
    }, [_vm._v(_vm._s(_vm.formatDate(key.created_at)))]), _vm._v(" "), _c('td', {
      staticClass: "aks-cell-action"
    }, [(!key.revoked_at) ? _c('button', {
      staticClass: "aks-revoke-btn",
      attrs: {
        "type": "button",
        "disabled": _vm.revokingId === key.id
      },
      on: {
        "click": function($event) {
          return _vm.confirmRevoke(key.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.revokingId === key.id ? 'Revoking…' : 'Revoke') + "\n              ")]) : _vm._e()])])
  }), 0)])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.tokenModal.show) ? _c('div', {
    staticClass: "aks-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeTokenModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "aks-modal"
  }, [_c('div', {
    staticClass: "aks-modal-icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "aks-modal-title"
  }, [_vm._v("API key created — save it now")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "aks-token-box"
  }, [_c('code', {
    staticClass: "aks-token-code"
  }, [_vm._v(_vm._s(_vm.tokenModal.token))]), _vm._v(" "), _c('button', {
    staticClass: "aks-copy-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.tokenModal.token)
      }
    }
  }, [(!_vm.copied) ? _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
    }
  }), _c('path', {
    attrs: {
      "d": "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
    }
  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.copied ? '✓ Copied!' : 'Copy') + "\n        ")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-primary aks-modal-done-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeTokenModal
    }
  }, [_vm._v("Done, I've copied it")])])]) : _vm._e(), _vm._v(" "), (_vm.revokeConfirmId != null) ? _c('div', {
    staticClass: "aks-overlay",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.revokeConfirmId = null
      }
    }
  }, [_c('div', {
    staticClass: "aks-modal aks-modal-sm"
  }, [_c('div', {
    staticClass: "aks-modal-icon-wrap aks-modal-icon-danger"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "aks-modal-title"
  }, [_vm._v("Revoke API key?")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "aks-modal-btns"
  }, [_c('button', {
    staticClass: "aks-btn aks-btn-outline",
    attrs: {
      "type": "button",
      "disabled": _vm.revokingId != null
    },
    on: {
      "click": function($event) {
        _vm.revokeConfirmId = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "aks-btn aks-btn-danger",
    class: {
      'aks-btn-loading': _vm.revokingId != null
    },
    attrs: {
      "type": "button",
      "disabled": _vm.revokingId != null
    },
    on: {
      "click": function($event) {
        return _vm.revokeKey(_vm.revokeConfirmId)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.revokingId != null ? 'Revoking…' : 'Revoke key') + "\n        ")])])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aks-page-head-text"
  }, [_c('h1', {
    staticClass: "aks-title"
  }, [_vm._v("API Keys")]), _vm._v(" "), _c('p', {
    staticClass: "aks-subtitle"
  }, [_vm._v("Authenticate requests to the SentryKit REST API from your own scripts, apps, or integrations.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n        Use your key in the "), _c('code', {
    staticClass: "aks-code"
  }, [_vm._v("Authorization: Bearer sk_live_…")]), _vm._v(" header when calling\n        "), _c('code', {
    staticClass: "aks-code"
  }, [_vm._v("https://api.sentrykit.com/api/external/v1/")]), _vm._v(".\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Scopes")]), _vm._v(" "), _c('th', [_vm._v("Last used")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "aks-modal-body"
  }, [_c('strong', [_vm._v("Copy this key now — it won't be shown again.")]), _vm._v("\n        Use it as "), _c('code', {
    staticClass: "aks-code"
  }, [_vm._v("Authorization: Bearer <key>")]), _vm._v(" in your API requests.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aks-example-block"
  }, [_c('p', {
    staticClass: "aks-example-label"
  }, [_vm._v("Example request")]), _vm._v(" "), _c('code', {
    staticClass: "aks-example-code"
  }, [_vm._v("curl -H \"Authorization: Bearer sk_live_…\" \\"), _c('br'), _vm._v("  https://api.sentrykit.com/api/external/v1/alerts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "aks-modal-body"
  }, [_vm._v("This immediately stops the key from authenticating. Any integration using it will break. "), _c('strong', [_vm._v("There is no undo")]), _vm._v(" — you'll need to create a new key.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8703e158!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ApiKeysSettings.vue
// module id = 801
// module chunks = 2